<template>
<div class="container">

    <div class="e2018_results_blocks">

        <template v-for="(election_type, election_index) in election_types" >

            <div :key="election_index" v-if="blacklist.indexOf(election_type.basename) == -1" class="results_block">

                <div v-if="loading" class="e2018_spinner">
                    <div>
                        <div></div>
                    </div>
                </div>

                <div class="title">
                <div class="text">&middot; <a :href="`${E2020_PUB_PATH}${election_type.basename}`" v-html="election_type.name"></a> &middot;</div>
                <div class="refresh" @click="fetch_data">Refresh</div>
                </div>

                <div v-if="first_load_done" class="overview">
                    <span v-if="election_type.basename == 'president'" > 
                        <span class="dem">Biden/Harris <a class="score" :href="`${E2020_PUB_PATH}${election_type.basename}`" v-html="vote_percent_display_pres('Biden') + ' (' + electoral_summary.Biden + ')      '"></a></span>
                        <span class="gop">Trump/Pence <a class="score" :href="`${E2020_PUB_PATH}${election_type.basename}`" v-html="vote_percent_display_pres('Trump')+ ' (' + electoral_summary.Trump + ')' "></a></span>
                    </span>
                    <span v-else> 
                        <span class="dem">Democrats <a class="score" :href="`${E2020_PUB_PATH}${election_type.basename}`" v-html="won_seats[election_type.basename]['dem'] + ( election_type.basename == 'senate' ? '* ' : ' ' ) + net_display(net_seats[election_type.basename]['dem'])"></a></span>
                        <span class="gop">Republicans <a class="score" :href="`${E2020_PUB_PATH}${election_type.basename}`" v-html="won_seats[election_type.basename]['gop'] + ' ' + net_display(net_seats[election_type.basename]['gop'])"></a></span>
                    </span>
                </div>

                <!-- President -->
                <template v-if="election_type.basename == 'president'">
                    <!-- Full Column -->
                    <table v-if="first_load_done" class="races full_column">
                    <template v-for="(ct, cti) in closing_times_index_define">
                        <tbody :key="cti" >
                            <tr>
                                <th v-html="ct"></th>
                                <th>Biden</th>
                                <th>Trump</th>
                                <th class="spacer"></th>
                                <th class="other_party" v-if="any_column_candidates(races[election_type.basename], 1)"></th>
                                <th class="percent_in"></th>
                                <!--<th></th>-->
                            </tr>
                            <template v-for="(race, index) in races[election_type.basename]">
                                <rc-widget-pres-row 
                                    v-if="closing_times[race.statePostal] == cti"
                                    :key="index"
                                    :races="races"
                                    :race="race"
                                    :election_type="election_type"
                                    :cti="cti"
                                ></rc-widget-pres-row>
                            </template>
                        </tbody>
                    </template>
                    </table>
                    <!-- Two Column -->
                    <table v-if="first_load_done" class="races left_column">
                    <template v-for="(ct, cti) in closing_times_index_define">
                        <tbody :key="cti" >
                            <tr>
                                <th v-html="ct"></th>
                                <th>Biden</th>
                                <th>Trump</th>
                                <th class="spacer"></th>
                                <th class="other_party" v-if="any_column_candidates(races[election_type.basename], 1)"></th>
                                <th class="percent_in"></th>
                                <!--<th></th>-->
                            </tr>
                            <template v-for="(race, race_index) in races[election_type.basename]" >
                                <rc-widget-pres-row 
                                    :key="race_index"
                                    v-if="closing_times[race.statePostal] == cti && order_in_closing_time(race_index) % 2 == 1"
                                    :races="races"
                                    :race="race"
                                    :election_type="election_type"
                                    :cti="cti"
                                ></rc-widget-pres-row>
                            </template>
                        </tbody>
                    </template>
                    </table>
                    
                    <table v-if="first_load_done" class="races right_column">
                    <template v-for="(ct, cti) in closing_times_index_define">
                        <tbody :key="cti" >
                        <tr>
                            <th></th>
                            <th>Biden</th>
                            <th>Trump</th>
                            <th class="spacer"></th>
                            <th class="other_party" v-if="any_column_candidates(races[election_type.basename], 1)"></th>
                            <th class="percent_in"></th>
                            <!--<th></th>-->
                        </tr>
                        <template v-for="(race, race_index) in races[election_type.basename]" >
                            <rc-widget-pres-row 
                                :key="race_index"
                                v-if="closing_times[race.statePostal] == cti && order_in_closing_time(race_index) % 2 == 0"
                                :races="races"
                                :race="race"
                                :election_type="election_type"
                                :cti="cti"
                            ></rc-widget-pres-row>
                        </template>
                        <tr v-if="last_in_closing_time_even(cti)"><td colspan="99">&nbsp;</td></tr>
                        </tbody>
                    </template>
                    </table>
                    
                </template>
                <!-- Other like senate, gov, house -->
                <table v-if="first_load_done" class="races">
                    <tbody v-if="election_type.basename != 'president'">
                        <tr>
                            <th></th>
                            <th>Democrat</th>
                            <th>Republican</th>
                            <th class="spacer"></th>
                            <th class="other_party" v-if="any_column_candidates(races[election_type.basename], 1)"></th>
                            <th class="percent_in"></th>
                            <th></th>
                        </tr>
                        <template v-for="(race, race_index) in races[election_type.basename]" >
                            <tr :key="race_index" :class="[{'race' : true}, winner_party(race), {'pickup' : winner_is_pickup(race)}, {'winner' : has_winner(race) || ['Georgia Special', 'Georgia'].indexOf(state_name_display(race.stateName, race.seatName, election_type.basename)) > -1}, {'is_ga_special': ['Georgia Special', 'Georgia'].indexOf(state_name_display(race.stateName, race.seatName, election_type.basename)) > -1}]">
                                <td class="name">
                                    <div>
                                        <a :href="race_detail_link(race, election_type.basename)" v-html="state_name_display(race.stateName, race.seatName, election_type.basename)"></a>
                                    </div>
                                </td>
                                <td v-for="(candidate, candidate_index) in candidates_with_party(race.reportingUnit.candidates, 'Dem', 1)" :key="candidate_index" class="candidate">
                                    <span v-html="candidate.last"></span> <span v-html="vote_perc_display(candidate.voteCount, race.voteTotal)"></span>
                                </td>
                                <td v-if="candidates_with_party(race.reportingUnit.candidates, 'Dem', 1).length == 0"></td>
                                <td v-for="(candidate, candidate_index) in candidates_with_party(race.reportingUnit.candidates, 'GOP', 1)" :key="candidate_index" class="candidate">
                                    <span v-html="candidate.last"></span> <span v-html="vote_perc_display(candidate.voteCount, race.voteTotal)"></span>
                                </td>
                                <td v-if="candidates_with_party(race.reportingUnit.candidates, 'GOP', 1).length == 0"></td>
                                <td v-for="(candidate, candidate_index) in column_candidates(race.reportingUnit.candidates, 1)" :key="candidate_index" class="candidate other_party" :style="state_name_display(race.stateName, race.seatName, election_type.basename) == 'Georgia Special' ? 'font-weight:normal;' : ''">
                                    <span v-html="candidate.last"></span> <span v-html="vote_perc_display(candidate.voteCount, race.voteTotal)"></span>
                                </td>
                                <td class="other_party" v-if="column_candidates(race.reportingUnit.candidates, 1).length == 0 && any_column_candidates(races[election_type.basename], 1)"></td>
                                <td class="spacer"></td>
                                <td class="percent_in"><div v-html="display_precincts_perc(race)"></div></td>
                                <td class="hold"><div v-html="winner_hold_pickup_text(race)"></div></td>
                            </tr>
                        </template>
                    </tbody>
                </table>

                <div class="footer" v-html="election_type.footer"></div>

            </div>

        </template>

    </div>

</div>
</template>

<script>

import ElectionNightMixin from './ElectionNightMixin.js';
import {rcp_refresh_interval, E2020_PUB_PATH} from './ElectionCommonVars.js';

const RcWidgetPresRow = () => import(/* webpackChunkName: "RcWidgetPresRow" */ "./RcWidgetPresRow.vue");

export default {
    name: '',
    mixins: [
        ElectionNightMixin,
    ],
    components: {
        'rc-widget-pres-row': RcWidgetPresRow,
    },
    props: {
        blacklist: {
            type: Array,
            default: function() { return [] },
        },
        house_alt: {
            type: Boolean,
            default: false,
        },
    },
    data : function() {
        return {
            "loading_interval" : 0,
            "loading" : true,
            "first_load_done" : false,
            "president_summary" : {},
            "electoral_summary" : {
                "Biden" : 0,
                "Trump" : 0,
            },
            "races" : {
                "president" : [],
                "senate" : [],
                "house" : [],
                "governor" : []
            },
            "election_types" : [
                {
                    "name" : "President",
                    "basename" : "president",
                    "footer" : "<a href='"+E2020_PUB_PATH+"/president/'>Click Here For All Presidential Results</a>"
                },
                {
                    "name" : "Senate",
                    "basename" : "senate",
                    "footer" : "<a href='"+E2020_PUB_PATH+"/senate/'>Click Here For All Senate Results</a>"
                },
                {
                    "name" : "House",
                    "basename" : "house",
                    "footer" : "<a href='"+E2020_PUB_PATH+"/house/'>All House Results</a> <span class='hide_on_phone_portrait'>| <a href='"+E2020_PUB_PATH+"/house_top_50/'>Top Races</a> </span>| <a href='"+E2020_PUB_PATH+"/house_northeast/'>Northeast</a> | <a href='"+E2020_PUB_PATH+"/house_midwest/'>Midwest</a> | <a href='"+E2020_PUB_PATH+"/house_south/'>South</a> | <a href='"+E2020_PUB_PATH+"/house_west/'>West</a>"
                },
                {
                    "name" : "Governors",
                    "basename" : "governor",
                    "footer" : "<a href='"+E2020_PUB_PATH+"/governor/'>Click Here For All Governor Results</a>"
                },
            ],
            "won_seats": {
                "president": {
                    "gop": 0,
                    "dem": 0,
                    "other": 0
                },
                "senate": {
                    "gop": 0,
                    "dem": 0,
                    "other": 0
                },
                "governor": {
                    "gop": 0,
                    "dem": 0,
                    "other": 0
                },
                "house": {
                    "gop": 0,
                    "dem": 0,
                    "other": 0
                }
            },
            "net_seats": {
                "president": {
                    "gop": 0,
                    "dem": 0,
                    "other": 0
                },
                "senate": {
                    "gop": 0,
                    "dem": 0,
                    "other": 0
                },
                "governor": {
                    "gop": 0,
                    "dem": 0,
                    "other": 0
                },
                "house": {
                    "gop": 0,
                    "dem": 0,
                    "other": 0
                }
            },
            "last_index": 0,
            "president_total_votes":0,
            "candidate_vote_counts":{},
            // "closing_times_index_define": [
            //   "6:00PM ET",  // 0
            //   "7:00PM ET",  // 1
            //   "7:30PM ET",  // 2
            //   "8:00PM ET",  // 3
            //   "8:30PM ET",  // 4
            //   "9:00PM ET",  // 5
            //   "10:00PM ET", // 6
            //   "11:00PM ET", // 7
            //   "12:00AM ET", // 8
            //   "1:00AM ET",  // 9
            // ],
            "closing_times_index_define": [
                "",  // 0
                //"",  // 1
                // "",  // 2
                // "",  // 3
                // "",  // 4
                // "7:30PM ET",  // 2
                // "8:00PM ET",  // 3
                // "8:30PM ET",  // 4
                // "9:00PM ET",  // 5
                // "10:00PM ET", // 6
                // "11:00PM ET", // 7
                // "12:00AM ET", // 8
                // "1:00AM ET",  // 9
                // "",           // 10
            ],
            // "closing_times": {  //Index for each state - see function for definishion closing_times_index_define
            //   "IN": 0,
            //   "KY": 0, 
            //   "FL": 1,
            //   "GA": 1,
            //   "SC": 1,
            //   "VA": 1,
            //   "VT": 1,
            //   "NC": 2,
            //   "OH": 2,
            //   "WV": 2,
            //   "AL": 3,
            //   "CT": 3,
            //   "DE": 3,
            //   "FL": 3,
            //   "IL": 3,
            //   "KS": 3,
            //   "ME": 3,
            //   "MD": 3,
            //   "MA": 3,
            //   "MI": 3,
            //   "MS": 3,
            //   "MO": 3,
            //   "NH": 3,
            //   "NJ": 3,
            //   "ND": 3,
            //   "OK": 3,
            //   "PA": 3,
            //   "RI": 3,
            //   "SD": 3,
            //   "TN": 3,
            //   "TX": 5,
            //   "DC": 3,
            //   "AR": 4,
            //   "AZ": 5,
            //   "CO": 5,
            //   "KS": 3,
            //   "LA": 5,
            //   "MI": 3,
            //   "MN": 5,
            //   "NE": 5,
            //   "NM": 5,
            //   "NY": 5,
            //   "ND": 3,
            //   "SD": 3,
            //   "WI": 5,
            //   "WY": 5,
            //   "ID": 6,
            //   "IA": 6,
            //   "MT": 6,
            //   "NV": 6,
            //   "OR": 6,
            //   "UT": 6,
            //   "CA": 7,
            //   "ID": 6,
            //   "OR": 6,
            //   "WA": 7,
            //   "AK": 9,
            //   "HI": 8,
            // }
            "closing_times": {  //Index for each state - see function for definishion closing_times_index_define
                "AZ": 0,
                "GA": 0,
                "NC": 0,
                "MN": 0,
                "PA": 0,
                "WI": 0,
                "NV": 0,
                "MI": 0,
                "IA": 0,
                "OH": 0,
                "TX": 0,
                "FL": 0,
                "IN": 1,
                "KY": 1, 
                "SC": 1,
                "VA": 1,
                "VT": 1,
                "WV": 1,
                "AL": 1,
                "CT": 1,
                "DE": 1,
                "IL": 1,
                "KS": 1,
                "ME": 1,
                "MD": 1,
                "MA": 1,
                "MS": 1,
                "MO": 1,
                "NH": 1,
                "NJ": 1,
                "ND": 1,
                "OK": 1,
                "RI": 1,
                "SD": 1,
                "TN": 1,
                "DC": 1,
                "AR": 1,
                "CO": 1,
                "KS": 1,
                "LA": 1,
                "NE": 1,
                "NM": 1,
                "NY": 1,
                "ND": 1,
                "SD": 1,
                "WY": 1,
                "ID": 1,
                "MT": 1,
                "OR": 1,
                "UT": 1,
                "CA": 1,
                "ID": 1,
                "OR": 1,
                "WA": 1,
                "AK": 1,
                "HI": 1,
            }
        };
    },
    created : function() {

        this.get_data_for_alpha_2();

        // Start refresh cron
        this.loading_interval = setInterval(() => {
            this.fetch_data();
        }, rcp_refresh_interval * 1000);
    },
    methods: {

        fetch_data : function() {

            if(!this.loading) {
                this.get_data_for_alpha_2();
            }
        },

        get_data_for_alpha_2 : function() {

            this.loading = true;
            // Retrieve live results data
            this.rcp_hp_fetch_data((response) => {

                // Successfully retrieved data

                this.won_seats = response.data.won_seats;
                this.net_seats = response.data.net_seats;
                this.president_summary = response.data.president_summary;
                this.electoral_summary = response.data.electoral_summary;

                // Calculate vote totals for each race based on candidates
                if(this.house_alt) {
                this.races['house'] = this.races_with_vote_totals(response.data.homepage_races['house_alt']);
                } else {
                this.races['house'] = this.races_with_vote_totals(response.data.homepage_races['house']);
                }

                this.races['senate'] = this.races_with_vote_totals(response.data.homepage_races['senate']);
                this.races['governor'] = this.races_with_vote_totals(response.data.homepage_races['governor']);
                this.races['president'] = this.races_with_vote_totals(response.data.homepage_races['president']);

                //Calculate vote count percentages and assign to object
                this.calculate_candites_votes();
                
                //Assign Closing Time Index
                this.assign_closing_time_index();

                //sort by closing time index
                // this.races['president'].sort(function(a,b) {
                //   return (a.closing_time_index > b.closing_time_index) ? 1 : -1;
                // });

                this.races['president'].sort(function(a,b) {
                //return (a.closing_time_index > b.closing_time_index) ? 1 : -1;
                //Order by closing_time_index first
                if (a.closing_time_index > b.closing_time_index) {
                    return 1;
                } else if (a.closing_time_index < b.closing_time_index) { 
                    return -1;
                }
            
                // Then by Display Order
                if (a.display_order < b.display_order) { 
                    return -1;
                } else if (a.display_order > b.display_order) {
                    return 1
                } else { // nothing to split them
                    return 0;
                }

                // // Then by Alphabet
                // if (a.stateName < b.stateName) { 
                //     return -1;
                // } else if (a.stateName > b.stateName) {
                //     return 1
                // } else { // nothing to split them
                //     return 0;
                // }
                });
                

                //assign counter (1,2,3, etc) to each time index
                this.assign_closing_time_index_tracker();

                this.first_load_done = true;
                this.loading = false;

            });
        },

        vote_percent_display_pres : function(cand){
            return this.candidate_vote_counts[cand] + '%';
        },

        calculate_candites_votes : function(){

            var total_votes = 0;
            for(let p=0; p < this.president_summary.candidates.length; p++){
                var can = this.president_summary.candidates[p];
                total_votes += parseInt(can.voteCount);
            }
            
            for(let p=0; p < this.president_summary.candidates.length; p++){
                var can = this.president_summary.candidates[p];
                
                var name = can.last;
                var can_vote_count = parseInt(can.voteCount);
                
                var percent = (can_vote_count / total_votes) * 100;

                if(total_votes == 0 || total_votes == 'undefined'){
                this.candidate_vote_counts[name] = 0;
                }else{
                this.candidate_vote_counts[name] = percent.toFixed(1);
                }
                
            }

        },

        order_in_closing_time : function(race_index) {

            for(var i = 0; i < this.closing_times_index_define.length; i++) {
                var current_count = 0;
                for(var j = 0; j < this.races.president.length; j++) {
                if(this.closing_times[this.races.president[j].statePostal] == i) {
                    current_count++;
                    if(j == race_index) {
                    return current_count;
                    }
                }
                }
            }
            return 0;
        },

        last_in_closing_time_even : function(cti) {

            var current_count = 0;
            for(var j = 0; j < this.races.president.length; j++) {
                if(this.closing_times[this.races.president[j].statePostal] == cti) {
                current_count++;
                }
            }
            return current_count % 2 ? true : false;
        },

        closing_times_races : function(closing_time_index1){

            var race =  this.races['president'].filter(function(c) {
                return c.closing_time_index == closing_time_index1;
            });

            return race;
        },

        assign_closing_time_index : function (){
            var president_data = this.races['president'];

            for(let i=0; i < president_data.length; i++){
                var state_postal = president_data[i].statePostal;

                this.races['president'][i]['closing_time_index'] = this.closing_times[state_postal];

                //D.N Display order for Top States
                if(state_postal == "FL"){ this.races['president'][i]['display_order'] = 0; }
                else if(state_postal == "PA"){ this.races['president'][i]['display_order'] = 1; }
                else if(state_postal == "MI"){ this.races['president'][i]['display_order'] = 2; }
                else if(state_postal == "OH"){ this.races['president'][i]['display_order'] = 3; }
                else if(state_postal == "WI"){ this.races['president'][i]['display_order'] = 4; }
                else if(state_postal == "MN"){ this.races['president'][i]['display_order'] = 5; }
                else if(state_postal == "IA"){ this.races['president'][i]['display_order'] = 6; }
                else if(state_postal == "NC"){ this.races['president'][i]['display_order'] = 7; }
                else if(state_postal == "GA"){ this.races['president'][i]['display_order'] = 8; }
                else if(state_postal == "TX"){ this.races['president'][i]['display_order'] = 9; }
                else if(state_postal == "AZ"){ this.races['president'][i]['display_order'] = 10; }
                else if(state_postal == "NV"){ this.races['president'][i]['display_order'] = 11; }
                else { this.races['president'][i]['display_order'] = 12; }

            }
        },
        assign_closing_time_index_tracker : function (){
            
            var president_data = this.races['president'];
            var counter = 0;
            var last_counter = 0;
            var close_index = null;

            for(let i=0; i < president_data.length; i++){
                close_index = president_data[i].closing_time_index;
                //last_counter
                if( last_counter != close_index ){
                counter = 0;
                this.races['president'][i]['closing_tracker_index'] = counter;
                }else{
                this.races['president'][i]['closing_tracker_index'] = counter;
                }
                counter = counter + 1;
                last_counter = close_index;
            }
        }

    },
}
</script>

<style lang="scss">

</style>